import React, { Component } from 'react'
import { Button, Drawer, Form } from 'antd';
import Swal from "sweetalert2";

class EditKontrak extends Component {
    constructor() {
        super();
        this.state = {
            contract_type: '',
            contract_start: '',
            contract_duration: '',
            contract_note: '',
            contract_status: '',
            successUpdate: false,
            loading: false
        }
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        if (name === 'contract_type' && value === 'tetap') {
            this.props.changeState({
                [name]: value,
                contract_duration: 0
            })
        } else {
            this.props.changeState({
                [name]: value
            })
        }
    }

    handleSubmit = () => {
        this.setState({
            loading: true
        })
        let form = {
            id: this.props.data.contract_id,
            karyawan: this.props.id,
            type: this.props.data.contract_type,
            start: this.props.data.contract_start,
            duration: this.props.data.contract_duration,
            note: this.props.data.contract_note,
            status: this.props.data.contract_status,
        }

        this.props.request("kontrak/update", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.props.changeState({
                        successUpdate: true,
                        contract_id: '',
                        contract_type: '',
                        contract_start: '',
                        contract_duration: '',
                        contract_note: '',
                        contract_status: '',
                        edit_visible: false,
                        data: [],
                        isLoading: true,
                        loading: true,
                    }, () => {
                        this.props.loadData()
                    })
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                } else if (response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({
                    loading: false
                })
            });
    }

    render() {
        return (
            <Drawer
                zIndex={2000}
                title="Ubah Data Kontrak"
                width={350}
                onClose={() => {
                    this.props.changeState({ edit_visible: false});
                }}
                visible={this.props.data.edit_visible}
                bodyStyle={{ paddingBottom: 80 }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={() => {
                            this.props.changeState({
                                edit_visible: false,
                                contract_type: '',
                                contract_start: '',
                                contract_duration: '',
                                contract_note: ''
                            });
                        }}
                                style={{ marginRight: 8 }}>
                            Batal
                        </Button>
                        <Button onClick={this.handleSubmit} disabled={this.state.loading} type="primary">
                            {this.state.loading ?
                                <><i className={"fa fa-refresh fa-spin"}></i> Loading</>
                                :
                                "Simpan Perubahan"
                            }
                        </Button>
                    </div>
                }
            >
                <Form layout="vertical" hideRequiredMark>
                    <div className="form-group">
                        <label>Tipe Kontrak</label>
                        <select
                            name="contract_type"
                            value={this.props.data.contract_type}
                            className="form-control col-xl-12 col-md-12"
                            onChange={this.handleChange}>
                            <option value="">Pilih Tipe Kontrak</option>
                            <option value="tetap">Tetap</option>
                            <option value="kontrak">Kontrak</option>
                            <option value="non-kontrak">Non-Kontrak</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Tanggal Mulai Kontrak</label>
                        <input style={{ fontSize: "12px" }} name="contract_start" value={this.props.data.contract_start} className="form-control" onChange={this.handleChange}
                               type="date" required="" />
                    </div>
                    {this.props.data.contract_type !== 'tetap' && (
                    <div className="form-group">
                        <label>Durasi Kontrak <small>(Durasi dalam Bulan)</small></label>
                        <input name="contract_duration" className="form-control col-xl-12 col-md-12" placeholder="Durasi Kontrak..."
                               value={this.props.data.contract_duration}
                               type="number" required
                               onChange={this.handleChange}/>
                    </div>
                    )}
                    <div className="form-group">
                        <label>Catatan Kontrak</label>
                        <input name="contract_note" className="form-control col-xl-12 col-md-12" placeholder="Catatan Kontrak..."
                               value={this.props.data.contract_note}
                               type="text" required=""
                               onChange={this.handleChange}/>
                    </div>
                    <div className="form-group">
                        <label>Status Kontrak</label>
                        <select
                            name="contract_status"
                            className="form-control col-xl-12 col-md-12"
                            value={this.props.data.contract_status}
                            onChange={this.handleChange}>
                            <option value="">Pilih Status Kontrak</option>
                            <option value="active">Aktif</option>
                            <option value="ended">Berakhir</option>
                        </select>
                    </div>
                </Form>
            </Drawer>

        )
    }
}

export default EditKontrak
